import { CIcon } from '~/icons/types'
export const ciPriceStatistics: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M12.86 9.46c.133 0 .26-.053.354-.146l6.106-6.106v3.015a.5.5 0 0 0 1 0V2c0-.01-.005-.018-.006-.028a.478.478 0 0 0-.306-.434c-.015-.006-.032-.005-.047-.01-.045-.013-.09-.028-.14-.028h-4.224a.5.5 0 0 0 0 1h3.017L12.86 8.253 9.495 4.888a.514.514 0 0 0-.707 0L3.826 9.85a.5.5 0 0 0 .708.707l4.608-4.608 3.365 3.366a.502.502 0 0 0 .353.145ZM6.36 16.5H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h4.36a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5Zm-.5 5H2.5v-4h3.36v4ZM14.18 13.275H9.82a.5.5 0 0 0-.5.5V22a.5.5 0 0 0 .5.5h4.359a.5.5 0 0 0 .5-.5v-8.224a.499.499 0 0 0-.5-.5Zm-.5 8.224h-3.36v-7.224h3.359V21.5ZM22 10.053h-4.36a.5.5 0 0 0-.5.5V22a.5.5 0 0 0 .5.5H22a.5.5 0 0 0 .5-.5V10.553a.5.5 0 0 0-.5-.5ZM21.5 21.5h-3.36V11.053h3.36V21.5Z'
    }
  ],
  name: 'price-statistics',
  type: 'thin'
}
